import { RemitDetails } from "us.collection.economy/constants/Actions";
import { IAPIAction } from "us.collection/interfaces";

const { GET_REMIT_DETAILS, GET_REMIT_DETAILS_SUCCESS, GET_REMIT_DETAILS_FAIL } =
  RemitDetails;

export const postRemitDetails: Readonly<IAPIAction> = {
  remitDetail: {
    get: (data) => ({
      type: GET_REMIT_DETAILS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_REMIT_DETAILS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_REMIT_DETAILS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
